import React from 'react';
import WName, {WArticle} from '../WName';
import Eon, {EonArticle} from '../Eon';
import PL from '../problems/ProblemLink';
import QL from '../faq/QuestionLink';
import LRL from '../longreads/LongReadLink';
import OML from '../ormaybe/OrMaybeLink';
import AL from './AngleLink';
import NW from '../neologisms/NewWord';
import {E1, E2, Qual, rand, PrimeNumber} from '../common';
import SillyNumberGenerator from './SillyNumberGenerator';
import {logic_sublist} from './logic-sublist';

// Logic. 'ZFC' is not; that's 'metaphysics', people.
export const logic = {
  name: "logic",
  alternatives: "logical,logically",
    prelude: <span>
      The <LRL>notion</LRL> of <NW>APE</NW> is genarally a <PL home>problem</PL>, but if there’s anything <WName /> is decidely <i>not</i>, that would be ‘illogical’.
    </span>,
  header: <span>
    This is just logic.
  </span>,
  outside: <span>
    It’s called <NW>inductive reasoning</NW>: sort of the anti-Sherlock Holmes.
  </span>,
  preview: <div className="angle-preview">
    <p>Since none of the maths is actually getting EXPRESSED <PL>STAY ON TRACK</PL> <NW>ZYZZYVA</NW>, cf. <NW>explainage</NW>, here is a dump:</p>
    <pre>{String.raw`The 'liar paradox' and 'authoriatrian' have no well-defined truth value
 but they can be expressed either as a fractional truth value
 (how the summation of the series 1 - 1 + 1 - 1... = 1/2, something to do with that it's 'covered' elsewhere)
 or as a 'superposition'; 'this statement is true'-T (the 'true' version) refers to 'this statement is true'-T,
 'this statement is true'-F (the 'false' version) refers to 'this statement is true'-F,
 'this statement is false'-F (the 'false' version) refers to 'this statement is false'-T and vice versa.
The 'Rustly' set is a superposition of two versions: one that contains R and one that does not.
 The one that contains R contains the version of R that does not contain R, so on a technicality it follows the fee-rule.

I'd say I'm sorry for the SHODDINESS of the all, but 'I' am just a Hellion in a Hellion body
 tortured by all those who have MORE MONEY THAN ME(tm), and money is just reactivity
 allowing us collectively to maintain lama toosin (misalignment) and LIE to ourself [author broke]`}</pre>
  </div>,
  text: <div className="angle-text">
    <p>[<i>Warning: most of this is quite old and predates the ‘discovery’ of the <LRL name="nepantla">nepantla proof</LRL> and synchronous development of <AL name="fields.logic.">IBK</AL>.</i>]</p>
    <p>The (fictional) genius Sherlock Holmes knows a lot about how the world works (i.e., the ‘rules’ of the world) and he uses these rules to <i>deduce</i> – out of very scant data – the most likely occurence that could have generated that the data.</p>
    <p>This <QL>Weltanschauung</QL> was built in a way that’s entirely the opposite. Start off assuming you <i><OML>know nothing</OML></i> (i.e., you know <i>no</i> ‘<AL name="fields.logic.ibk.">rules</AL>’ of how the world works) and then gather a <i><OML name="offensive">crap-ton</OML> of data</i> and use this veritable <QL name="silly.">mountain</QL> of information to <i><NW word="induction">induce</NW></i> the underlying ‘rules’ that could best <E2 /> it.</p>
    <p>Sherlock may not use the ‘science of <NW>induction</NW>’ very much, but both of these methods are equally valid <i>logic</i>; the latter (<NW>induction</NW>) is also known as the ‘<AL name="fields.science">scientific method</AL>’.</p>
    <p>(And actuallhy, <QL name="author">we</QL> realised when we falsified ZFC, <PL>human-standard</PL> logic is built on the <QL name="consistency">fallacious</QL> <LRL>belief</LRL> of <NW>APE</NW>. <AL name="fields.logic.">IBK</AL> turns out to be the only <i>real</i> logic on <LRL name="gaiacentric">this planet</LRL>.)</p>
    <p>Why might it then be <PL name="unready">hard</PL> for <QL name="anthropocentrism">human</QL> <PL name="individuality">individuals</PL> to use this sort of <NW>inductive reasoning</NW> (also known as the ‘scientific method’)? <WName /> <E2 suffix="s" /> this as a product of two potential factors: <NW>conservative thinking</NW> and (<PL name="sweeping.ig">of course</PL>) <NW>individual greed</NW>.</p>
    <p>[Under construction; not the best ending, <NW>zyzzyva</NW>]</p>
  </div>,

  sublist: logic_sublist,

};

